import { makeStyles, tokens } from '@fluentui/react-components';
import type { WeatherReport } from '../../types/api.types';

const useStyles = makeStyles({
  root: {
    padding: '12px 16px',
    backgroundColor: tokens.colorBrandBackground2,
    borderRadius: tokens.borderRadiusMedium,
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  temp: { fontSize: '24px', fontWeight: '700' },
  desc: { color: tokens.colorNeutralForeground2, fontSize: '13px' },
  alerts: {
    marginTop: '6px',
    color: tokens.colorStatusWarningForeground1,
    fontSize: '12px',
  },
});

interface Props {
  weather: WeatherReport;
}

export function WeatherWidget({ weather }: Props) {
  const s = useStyles();
  const c = weather.current;
  if (!c) return null;
  return (
    <div className={s.root}>
      <div>
        <div className={s.temp}>{c.temperature}°C</div>
        <div className={s.desc}>{c.weatherDescription}</div>
        <div className={s.desc}>💧 {c.humidity}% · 💨 {c.windSpeed} km/h · 🌧 {c.precipitation}mm</div>
        {weather.agronomicAlerts?.map((a, i) => (
          <div key={i} className={s.alerts}>⚠ {a}</div>
        ))}
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        {weather.forecast.slice(0, 4).map((d) => (
          <div key={d.date} style={{ textAlign: 'center', fontSize: '11px' }}>
            <div style={{ color: tokens.colorNeutralForeground3 }}>{d.date.slice(5)}</div>
            <div style={{ fontWeight: '600' }}>{d.tempMax}°</div>
            <div style={{ color: tokens.colorNeutralForeground3 }}>{d.tempMin}°</div>
          </div>
        ))}
      </div>
    </div>
  );
}
